import * as React from "react";
import { SpotMobileUserIcon, SpotChatIcon } from "@origin-digital/icon";
import { CardProps } from "@origin-digital/ods-core";
import { CallToActionCard } from "../CallToActionCard";
import content from "../../cms/loginViewMessages.json";
import { useAppContext } from "../../AppContext";

interface ICTACard {
  text: string;
  cta: {
    text: string;
    path: string;
  };
}

const callToAction = (
  ctaContent: ICTACard,
  icon: React.ReactNode,
  backgroundColor: CardProps["backgroundColor"],
  dataId?: string
): JSX.Element => (
  <CallToActionCard
    text={ctaContent.text}
    icon={icon}
    cta={ctaContent.cta.text}
    onClick={() => window.location.assign(ctaContent.cta.path)}
    backgroundColor={backgroundColor}
    data-id={dataId}
  />
);

export interface IProps {
  __authed?: boolean; // private: for use primarily is Storybook
  backgroundColor?: CardProps["backgroundColor"];
  "data-id"?: string;
}

export const LoginViewMessagesController = ({
  __authed,
  "data-id": dataId,
  backgroundColor,
}: IProps): JSX.Element => {
  const { isAuthenticated, config } = useAppContext();
  return __authed || isAuthenticated ? (
    config.toggles?.contactUs ? (
      callToAction(
        content.auth,
        <SpotChatIcon data-id={dataId} size={72} />,
        backgroundColor,
        `${dataId}:ViewMessages`
      )
    ) : (
      <></>
    )
  ) : (
    callToAction(
      content.unauth,
      <SpotMobileUserIcon data-id={dataId} size={72} />,
      backgroundColor,
      `${dataId}:LogIn`
    )
  );
};
